var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFransaviLeftDoubleDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.8,29.3l-0.1,0c-0.3-0.1-0.4-0.4-0.3-0.6l0.6-2c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-0.6,2 C1.2,29.1,1,29.3,0.8,29.3z M2.3,24.5l-0.1,0c-0.3-0.1-0.4-0.4-0.3-0.6L3,20.2c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6 l-1.2,3.7C2.7,24.3,2.5,24.5,2.3,24.5z M4.3,18l-0.1,0c-0.3-0.1-0.4-0.4-0.3-0.6L5,13.7c0.1-0.3,0.4-0.4,0.6-0.3 C5.9,13.5,6.1,13.7,6,14l-1.2,3.7C4.7,17.9,4.5,18,4.3,18z M6.4,11.6l-0.1,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.2-3.7 C7.2,7,7.5,6.8,7.7,6.9C8,7,8.1,7.3,8,7.5l-1.2,3.7C6.8,11.4,6.6,11.6,6.4,11.6z M8.4,5.1l-0.1,0C8,5,7.9,4.7,8,4.5l1.2-3.7 c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6L8.9,4.8C8.8,5,8.6,5.1,8.4,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,29.3c-0.2,0-0.4-0.1-0.5-0.3l-1.3-3.7c-0.1-0.3,0-0.5,0.3-0.6c0.3-0.1,0.5,0,0.6,0.3l1.3,3.7 c0.1,0.3,0,0.5-0.3,0.6L19.8,29.3z M17.6,22.9c-0.2,0-0.4-0.1-0.5-0.3l-1.3-3.7c-0.1-0.3,0-0.5,0.3-0.6c0.3-0.1,0.5,0,0.6,0.3 l1.3,3.7c0.1,0.3,0,0.5-0.3,0.6L17.6,22.9z M15.3,16.5c-0.2,0-0.4-0.1-0.5-0.3l-1.3-3.7c-0.1-0.3,0-0.5,0.3-0.6 c0.3-0.1,0.5,0,0.6,0.3l1.3,3.7c0.1,0.3,0,0.5-0.3,0.6L15.3,16.5z M13.1,10.1c-0.2,0-0.4-0.1-0.5-0.3l-1.3-3.7 c-0.1-0.3,0-0.5,0.3-0.6c0.3-0.1,0.5,0,0.6,0.3l1.3,3.7c0.1,0.3,0,0.5-0.3,0.6L13.1,10.1z M10.8,3.7c-0.2,0-0.4-0.1-0.5-0.3 L9.6,1.1c-0.1-0.3,0-0.5,0.3-0.6c0.3-0.1,0.5,0,0.6,0.3L11.3,3c0.1,0.3,0,0.5-0.3,0.6L10.8,3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8,25.9H4.7V5.2h11.1V25.9z M5.7,24.9h9.2V6.1H5.7V24.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 15.1,
    rx: 2.2,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,15.8c-0.1,0-0.2,0-0.3-0.1L0.6,1.3C0.4,1.1,0.4,0.8,0.6,0.6C0.7,0.4,1,0.4,1.2,0.6l17.1,14.4 c0.2,0.2,0.2,0.5,0.1,0.7C18.3,15.7,18.2,15.8,18,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9,29.3c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l17.1-13.5c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.2,0.1,0.5-0.1,0.7L1.2,29.2C1.1,29.2,1,29.3,0.9,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M1,29H29V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,25.7h-3.6V4.9h3.6V25.7z M23.8,24.7h1.7V5.9h-1.7V24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,29.7c-0.3,0-0.5-0.2-0.5-0.5V0.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.3 C20.4,29.5,20.2,29.7,19.9,29.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFransaviLeftDoubleDoor);
export default __webpack_public_path__ + "static/media/fransavi_left_double_door.1d884a28217e633b57264b6f26b66c24.svg";
export { ForwardRef as ReactComponent };